import { useQuery } from '@tanstack/react-query';
import { queryKeyFactory } from 'utils/query-client';
import { loaders } from './jobs.loaders';
import { converters } from './jobs.converters';

export const jobsKeys = queryKeyFactory('jobs');

export const useJobStatus = (
  { queue, jobId }: { queue: string; jobId: string },
  options: { refetchInterval?: number } = {},
) => {
  return useQuery({
    queryKey: jobsKeys.detail('status', queue, jobId),
    queryFn: () => loaders.getJobStatus({ queue, jobId }),
    select: converters.getJobStatus,
    enabled: !!queue && !!jobId,
    refetchInterval: (data) => {
      if (data?.state === 'success' || data?.state === 'error') {
        return false;
      }

      return options.refetchInterval ?? false;
    },
  });
};
